export default "__VITE_ASSET__75a1c11c__$_?component__"